export default __webpack_public_path__ + "static/DSC_0077-31e2994c4a35ce008c5d6320f86a2ae6.jpg";